import { inject, Injectable } from '@angular/core';
import { FullStory } from '@fullstory/browser';
import { delay, distinctUntilChanged, filter, map, retry, take, tap } from 'rxjs';
import { TokenData } from '../../../interfaces';
import { AuthService } from '../auth/auth.service';

@Injectable({
	providedIn: 'root',
})
export class FullStoryService {
	#auth = inject(AuthService);

	init() {
		this.#listenAuthenticatedToken();
	}

	trackEvent(name: string, properties: Record<string, any> = {}): void {
		FullStory('trackEvent', {
			name,
			properties,
		});
	}

	trackErrorEvent(description: string, error: any) {
		this.trackEvent('ERROR', { description, error });
	}

	refreshSession() {
		this.shutdown();
		this.restart();
	}

	shutdown() {
		FullStory('shutdown');
	}

	restart() {
		FullStory('restart');
	}

	#listenAuthenticatedToken() {
		this.#auth.accessToken$
			.pipe(
				distinctUntilChanged(),
				// Delayp para aguardar os demais scripts do SDK carregar
				delay(1000),
				filter((token) => !!token),
				map(() => this.#auth.getTokenData()),
				filter((tokenData) => !!tokenData && !tokenData.isExpired),
				// Sö pega o primeiro
				take(1),
				// Forçando o casting porque o valor já existe, o filter acima garante isso
				tap((data) => this.#identify(data as TokenData)),
				// Retry 2 vezes em caso de erro
				retry(2),
			)
			.subscribe();
	}

	#identify({ sub, email }: Pick<TokenData, 'sub' | 'email'>) {
		FullStory('setIdentity', {
			uid: sub,
			properties: {
				unit: this.#auth.getUserUnit(),
				email,
			},
		});
	}
}
